
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"var(--brand-primary-dark)"}}),_c('rect',{attrs:{"width":"16","height":"12","x":"12","y":"14","fill":"var(--brand-primary-lighter)","rx":"2"}}),_c('path',{attrs:{"stroke":"var(--brand-primary-dark)","stroke-linecap":"round","stroke-width":"1.5","d":"M22 18l-4 4m0-4l4 4"}})])
          )
        }
      }
    